<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-flex md12>
            <material-card color="green" title="Grid Totals" class="grid-card">
                <v-btn @click="log">log</v-btn>
                <DxPivotGrid
                    :allow-sorting="true"
                    :allow-sorting-by-summary="true"
                    :on-content-ready="onGridLoaded"
                    :allow-filtering="true"
                    :height="620"
                    :show-borders="true"
                    :data-source="dataSource"
                    :onRowExpanding="onGridLoaded"
                    row-header-layout="tree"
                >
                    <DxExport :enabled="true" file-name="Sales" />
                    <DxStateStoring
                        :enabled="true"
                        storage-key="purim-totals"
                    />
                </DxPivotGrid>
            </material-card>
        </v-flex>
    </v-container>
</template>

<script>
import { pluralize, sum } from "../../utils/helpers.js";
import moment from "moment";
import {
    DxPivotGrid,
    DxScrolling,
    DxExport,
    DxFieldChooser,
    DxStateStoring
} from "devextreme-vue/pivot-grid";

import { createStore } from "devextreme-aspnet-data-nojquery";

export default {
    components: {
        DxPivotGrid,
        DxExport,
        DxFieldChooser,
        DxStateStoring
    },
    data: () => ({
        ///odata/purimStudents?%24filter=isActive%20eq%20true
        dataSource: {
            remoteOperations: true,
            store: createStore({
                key: "studentID",
                loadUrl:
                    "https://localhost:44338/api/purimStudents/getStudents",
                onLoaded: function(result) {
                    console.log(result);
                }
            }),
            fields: [
                {
                    caption: "Branch",
                    dataField: "branch",
                    dataType: "string",
                    area: "column"
                }
                // {
                //     caption: "Category",
                //     dataField: "ProductCategoryName",
                //     width: 250,
                //     expanded: true,
                //     sortBySummaryField: "SalesAmount",
                //     sortBySummaryPath: [],
                //     sortOrder: "desc",
                //     area: "row"
                // },
                // {
                //     caption: "Subcategory",
                //     dataField: "ProductSubcategoryName",
                //     width: 250,
                //     sortBySummaryField: "SalesAmount",
                //     sortBySummaryPath: [],
                //     sortOrder: "desc",
                //     area: "row"
                // },
                // {
                //     caption: "Product",
                //     dataField: "ProductName",
                //     area: "row",
                //     sortBySummaryField: "SalesAmount",
                //     sortBySummaryPath: [],
                //     sortOrder: "desc",
                //     width: 250
                // },
                // {
                //     caption: "Date",
                //     dataField: "DateKey",
                //     dataType: "date",
                //     area: "column"
                // },
                // {
                //     caption: "Amount",
                //     dataField: "SalesAmount",
                //     summaryType: "sum",
                //     format: "currency",
                //     area: "data"
                // },
                // {
                //     caption: "Store",
                //     dataField: "StoreName"
                // },
                // {
                //     caption: "Quantity",
                //     dataField: "SalesQuantity",
                //     summaryType: "sum"
                // },
                // {
                //     caption: "Unit Price",
                //     dataField: "UnitPrice",
                //     format: "currency",
                //     summaryType: "sum"
                // },
                // {
                //     dataField: "Id",
                //     visible: false
                // }
            ]
        }
    }),
    watch: {},
    created() {},
    methods: {
        log() {
            console.log(this.dataSource);
        },
        onGridLoaded(grid) {
            console.log(grid);
        }
    }
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}
.v-btn__content {
    color: unset;
}
</style>
